import { headType } from "./head-type.enum";

export enum headUnitEndsWith {
    staircase = 'staircase',
    units = 'units',
    special = 'special',
}

export enum preference {
    yes = 'yes',
    no = 'no',
    optional = 'optional'
}

export enum alignsWithBuilding {
    none = 'none',
    perpendicular = 'perpendicular',
    parallel = 'parallel',
}

export interface HeadType {
    type: headType,
    alignsWithBuilding: alignsWithBuilding,
    endsWith?: headUnitEndsWith,
    preferred?: preference,
    highrise?: boolean, // > 20m.
    description?: string,
    uiName?: string,
}

export const defaultHeadLeft = headType.none;
export const defaultHeadRight = headType._O_TH2;

export const headTypesModel: HeadType[] = [
    {
        type: headType.none,
        alignsWithBuilding: alignsWithBuilding.none,
        highrise: true,
    },
    {
        type: headType.G_M__O_TH2,
        alignsWithBuilding: alignsWithBuilding.parallel,
        endsWith: headUnitEndsWith.units,
        preferred: preference.yes,
        highrise: true,
        description: 'M appartment with high-rise staircase',
        uiName: 'M app. + trappenhuis',
    },
    {
        type: headType.G_XL__O_TH2,
        alignsWithBuilding: alignsWithBuilding.parallel,
        endsWith: headUnitEndsWith.units,
        preferred: preference.yes,
        highrise: true,
        description: 'XL apartment with high-rise staircase',
        uiName: 'XL app. + trappenhuis',
    },
    {
        type: headType.G_M__O_TLH2,
        alignsWithBuilding: alignsWithBuilding.parallel,
        endsWith: headUnitEndsWith.units,
        preferred: preference.yes,
        highrise: true,
        description: 'M apartment with elevator and staircase',
        uiName: 'M app. + lift',
    },
    {
        type: headType.G_XL__O_TLH2,
        alignsWithBuilding: alignsWithBuilding.parallel,
        endsWith: headUnitEndsWith.units,
        preferred: preference.yes,
        highrise: true,
        description: 'XL apartment with elevator and staircase',
        uiName: 'XL app. + lift',
    },
    {
        type: headType._O_TH2,
        alignsWithBuilding: alignsWithBuilding.parallel,
        endsWith: headUnitEndsWith.staircase,
        preferred: preference.no,
        highrise: true,
        description: 'Large staircase',
        uiName: 'Trappenhuis (standaard)',
    },
    {
        type: headType._O_TLH2,
        alignsWithBuilding: alignsWithBuilding.parallel,
        endsWith: headUnitEndsWith.staircase,
        preferred: preference.no,
        highrise: true,
        description: 'Staircase and elevator',
        uiName: 'Lift + trappenhuis',

    },
    {
        type: headType._2G_MH,
        alignsWithBuilding: alignsWithBuilding.perpendicular,
        endsWith: headUnitEndsWith.special,
        preferred: preference.optional,
        highrise: true,
        description: 'Rotated head with two M apartments, high-rise',
        uiName: '2x M app. gedraaid + lift',
    },
    {
        type: headType._2G_LH,
        alignsWithBuilding: alignsWithBuilding.perpendicular,
        endsWith: headUnitEndsWith.special,
        preferred: preference.optional,
        highrise: true,
        description: 'Rotated head with two L apartments, high-rise',
        uiName: '2x L app. gedraaid + lift',
    },
    {
        type: headType._2G_M,
        alignsWithBuilding: alignsWithBuilding.perpendicular,
        endsWith: headUnitEndsWith.special,
        preferred: preference.optional,
        highrise: false,
        description: 'Rotated head with two M apartments, low-rise',
        uiName: '2x M app. gedraaid + trappenhuis',
    },
    {
        type: headType._2G_L,
        alignsWithBuilding: alignsWithBuilding.perpendicular,
        endsWith: headUnitEndsWith.special,
        preferred: preference.optional,
        highrise: false,
        description: 'Rotated head with two L apartments, low-rise',
        uiName: '2x L app. gedraaid + trappenhuis',
    },
]
